const prefix = 'CONTACT_INFORMATION_';

export const ContactInformationActionTypes = {
  GET_ADDRESS_LIST: `${prefix}GET_ADDRESS_LIST`,
  SET_ADDRESS_LIST: `${prefix}SET_ADDRESS_LIST`,
  SET_NEW_ADDRESS: `${prefix}SET_NEW_ADDRESS`,
  SET_DATA_LOADING: `${prefix}SET_DATA_LOADING`,
  SET_DELETE_ADDRESS: `${prefix}SET_DELETE_ADDRESS`,
  SET_SELECTED_ADDRESS: `${prefix}SET_SELECTED_ADDRESS`,
  SET_ADDRESS_TEXT: `${prefix}SET_ADDRESS_TEXT`,
  SET_ADDRESS_UNIT: `${prefix}SET_ADDRESS_UNIT`,
  SET_ADDRESS_PLATE: `${prefix}SET_ADDRESS_PLATE`,
  SET_ADDRESS_LOCATION: `${prefix}SET_ADDRESS_LOCATION`,
  CLEAR_NEW_ADDRESS: `${prefix}CLEAR_NEW_ADDRESS`,
  SET_NEW_ADDRESS_ID: `${prefix}SET_NEW_ADDRESS_ID`,
  RESET_ADDRESS_ITEMS: `${prefix}RESET_ADDRESS_ITEMS`,
  GET_EDIT_ADDRESS: `${prefix}GET_EDIT_ADDRESS`,
  SET_EDIT_ADDRESS: `${prefix}SET_EDIT_ADDRESS`,
  SET_EDIT_ADDRESS_INITIAL: `${prefix}SET_EDIT_ADDRESS_INITIAL`,
  SET_EDIT_ADDRESS_TEXT: `${prefix}SET_EDIT_ADDRESS_TEXT`,
  SET_EDIT_ADDRESS_LOCATION: `${prefix}SET_EDIT_ADDRESS_LOCATION`,
  SET_EDIT_ADDRESS_UNIT: `${prefix}SET_EDIT_ADDRESS_UNIT`,
  SET_EDIT_ADDRESS_PLATE: `${prefix}SET_EDIT_ADDRESS_PLATE`,
  GET_EXTENDED_ADDRESS_LIST: `${prefix}GET_EXTENDED_ADDRESS_LIST`,
};

const getAddressList = (data?: {cityId?: string | undefined}) => ({ type: ContactInformationActionTypes.GET_ADDRESS_LIST, data: data });
const setDeleteAddress = (data: { deletedAddressId: string }) => ({ type: ContactInformationActionTypes.SET_DELETE_ADDRESS, data: data });
const setSelectedAddress = (data: { selectedAddress: string, selectedAddressId: string, addressIndex: number, latitude: string, longitude: string }) => ({ type: ContactInformationActionTypes.SET_SELECTED_ADDRESS, data: data });
const setNewAddress = (data: { newAddress: { address: string, longitude: string, latitude: string, unit: string, plate: string, cityId: string } }) => ({ type: ContactInformationActionTypes.SET_NEW_ADDRESS, data: data });
const setAddressText = (data: { address: string }) => ({ type: ContactInformationActionTypes.SET_ADDRESS_TEXT, data: data });
const setAddressUnit = (data: { unit: string }) => ({ type: ContactInformationActionTypes.SET_ADDRESS_UNIT, data: data });
const setAddressPlate = (data: { plate: string }) => ({ type: ContactInformationActionTypes.SET_ADDRESS_PLATE, data: data });
const setAddressLocation = (data: { addressLocation: object }) => ({ type: ContactInformationActionTypes.SET_ADDRESS_LOCATION, data: data });

const getEditAddress = (data: { editAddressId: string, editAddressText: string, editAddressPlate: string, editAddressUnit: string, editAddressLocation: any }) => ({ type: ContactInformationActionTypes.GET_EDIT_ADDRESS, data: data });
const setEditAddressText = (data: { editAddressText: string }) => ({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_TEXT, data: data });
const setEditAddressUnit = (data: { editAddressUnit: string }) => ({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_UNIT, data: data });
const setEditAddressPlate = (data: { editAddressPlate: string }) => ({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_PLATE, data: data });
const setEditAddress = () => ({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS });
const setEditAddressLocation = (data: { editAddressLocation: any }) => ({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_LOCATION, data: data });
const getExtendedAddressList = () => ({ type: ContactInformationActionTypes.GET_EXTENDED_ADDRESS_LIST });

export const ClientAddressActions = {
  getAddressList: getAddressList,
  setDeleteAddress: setDeleteAddress,
  setSelectedAddress: setSelectedAddress,
  setNewAddress: setNewAddress,
  setAddressText: setAddressText,
  setAddressUnit: setAddressUnit,
  setAddressPlate: setAddressPlate,
  setAddressLocation: setAddressLocation,
  getEditAddress: getEditAddress,
  setEditAddress: setEditAddress,
  setEditAddressText: setEditAddressText,
  setEditAddressLocation: setEditAddressLocation,
  setEditAddressUnit: setEditAddressUnit,
  setEditAddressPlate: setEditAddressPlate,
  getExtendedAddressList: getExtendedAddressList,
};
